import Slider from "react-slick";
export default function SliderBanner({ slideritems }) {

    function SampleNextArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div
                className={className}
                onClick={onClick}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16"> <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/> </svg>
            </div>
        );
    }
    
    function SamplePrevArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div
                className={className}
                onClick={onClick}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16"> <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/> </svg>
            </div>
        );
    }


    const settings = {
        dots: false,
        infinite: true,
        arrows: true,
        speed: 500,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        slidesToShow: 1,
        slidesToScroll: 1
    };  
	return (
		<>
            
                <div class="container">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="kitbug-items-slider arrow-design-two" >
                                {slideritems && 
                                    <Slider  {...settings}>
                                        {
                                            slideritems.map(
                                                ({title, buttonUrl, imagesUrl}, index) => {
                                                    return(
                                                        <div class="slider-me">
                                                            <div class="kitbug-img-slider-items">
                                                               
                                                                    <img src={imagesUrl} alt={title} />
                                                                
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                            )
                                        }
                                    </Slider>
                                }
                            </div>
                        </div>
                    </div>
                </div>
		</>
	);
}

                    
